import { useTranslation } from 'react-i18next';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { InputAdornment } from '@mui/material';
import { GRAY_SECONDARY } from 'constants/colors';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import { useEffect } from 'react';
import { DistanceAndAmountSectionProps } from '../types';

const DistanceAndAmountSection = ({
  control,
  isFieldHidden,
  watch,
  setValue
}: DistanceAndAmountSectionProps) => {
  const { t } = useTranslation('common');
  const distanceKm = watch && watch('distanceKm');
  const travelExpensesNominal = watch && watch('travelExpensesNominal');

  useEffect(() => {
    if (!distanceKm) setValue('distanceKm', null);
    if (!travelExpensesNominal) setValue('travelExpensesNominal', null);
  }, [distanceKm, travelExpensesNominal, setValue]);

  return (
    <>
      <MultiStepForm.Section
        title={
          isFieldHidden?.('distanceAndAmount.amount')
            ? t('travelArrangements.distance')
            : t('travelArrangements.distanceAndAmount')
        }
        validateFields={
          isFieldHidden?.('distanceAndAmount.amount')
            ? ['distanceKm']
            : ['distanceKm', 'amount']
        }
      >
        <ControlledNumericField
          name="distanceKm"
          control={control}
          variant="outlined"
          label={t('travelArrangements.singleDistance')}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                disableTypography
                sx={{ color: GRAY_SECONDARY, fontSize: '12px' }}
              >
                km
              </InputAdornment>
            )
          }}
        />
        {!isFieldHidden?.('distanceAndAmount.amount') && (
          <ControlledNumericField
            name="travelExpensesNominal"
            control={control}
            variant="outlined"
            label={t('travelArrangements.amountSingleDistance')}
          />
        )}
      </MultiStepForm.Section>
    </>
  );
};

export default DistanceAndAmountSection;
